import { render, staticRenderFns } from "./interactive-video-exam-player.vue?vue&type=template&id=1ce65444&scoped=true"
import script from "./interactive-video-exam-player.vue?vue&type=script&lang=js"
export * from "./interactive-video-exam-player.vue?vue&type=script&lang=js"
import style0 from "./interactive-video-exam-player.css?vue&type=style&index=0&id=1ce65444&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce65444",
  null
  
)

export default component.exports